import { Tag } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { ColumnsType } from "antd/es/table";
import { t } from "i18next";
import { FilterItem, FilterItemType } from "../../filters/filters.types";
import {
  MfListaObjekataPsPayload,
  MfListaObjekataPsProps,
} from "./centralRegistry.types";

export const MF_OBJEKTI_PRIVREDNIH_SUBJEKATA_INITIAL_FILTERS: MfListaObjekataPsPayload =
  {
    pib: null,
    tipObjektaId: null,
  };

export const getMfListaObjekataPsFilterItems = ({
  isLoading,
  tipObjektaOptions,
}: {
  isLoading?: boolean;
  tipObjektaOptions?: DefaultOptionType[];
}): Array<FilterItem<MfListaObjekataPsPayload>> => [
  {
    fieldName: "pib",
    type: FilterItemType.TEXT,
    props: {
      placeholder: t("PLACEHOLDERS.PIB"),
    },
  },
  {
    fieldName: "tipObjektaId",
    type: FilterItemType.SELECT,
    props: {
      placeholder: t("TABLES.TIP_OBJEKTA"),
      loading: isLoading,
      options: tipObjektaOptions,
    },
  },
];

export const getMfListaObjekataPsTableColumns = () => {
  const columns: ColumnsType<MfListaObjekataPsProps> = [
    {
      title: t("TABLES.NAZIV_PRIVREDNOG_SUBJEKTA"),
      dataIndex: "psNaziv",
      width: "220px",
    },
    {
      title: t("COMMON.PIB"),
      dataIndex: "pib",
      width: "120px",
    },
    {
      title: t("TABLES.ID_OBJEKTA"),
      dataIndex: "idObjekta",
      width: "120px",
    },
    {
      title: t("TABLES.NAZIV_OBJEKTA"),
      dataIndex: "nazivObjekta",
      width: "220px",
    },
    {
      title: t("TABLES.TIP_OBJEKTA"),
      dataIndex: "tipObjekta",
      width: "220px",
    },
    {
      title: t("TABLES.STATUS"),
      dataIndex: "aktivan",
      width: "100px",
      render: (aktivan: boolean) => (
        <Tag color={aktivan ? "success" : "error"}>
          {aktivan ? t("COMMON.AKTIVAN") : t("COMMON.NEAKTIVAN")}
        </Tag>
      ),
    },
  ];

  return columns;
};

export const getMfListaObjekataPsExcelColumns = () => [
  {
    title: t("TABLES.NAZIV_PRIVREDNOG_SUBJEKTA"),
    dataIndex: "psNaziv",
    excelWidth: 40,
  },
  {
    title: t("COMMON.PIB"),
    dataIndex: "pib",
    excelWidth: 20,
  },
  {
    title: t("TABLES.ID_OBJEKTA"),
    dataIndex: "idObjekta",
    excelWidth: 20,
  },
  {
    title: t("TABLES.NAZIV_OBJEKTA"),
    dataIndex: "nazivObjekta",
    excelWidth: 40,
  },
  {
    title: t("TABLES.TIP_OBJEKTA"),
    dataIndex: "tipObjekta",
    excelWidth: 30,
  },
  {
    title: t("TABLES.STATUS"),
    dataIndex: "aktivan",
    excelWidth: 15,
    excelValueFormatter: (aktivan: boolean) =>
      aktivan ? t("COMMON.AKTIVAN") : t("COMMON.NEAKTIVAN"),
  },
];
